import React,{Fragment} from 'react';
import OrderItem from './OrderItem';
import { withRouter } from 'react-router-dom';

const OrderItemBlock = (props) => {

    const renderOrders = () => (
        props.list ? 
            props.list.map(card=>(
                <OrderItem
                    key={card._id}
                    handelOnClickExistingOrder={props.handelOnClickExistingOrder}
                    {...card}
                />
            ))
        :null
    )

    return (
        <Fragment>
            {props.list ?
                props.list.length === 0 ?
                    <tr className="no_result text-center">
                       <td colSpan="4"> You have not placed any orders yet.</td>
                    </tr>
                :null
            :null}
            { renderOrders(props.list)}

        </Fragment>
    );
};

export default withRouter(OrderItemBlock);